/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConnectorPlugin
 */
export interface ConnectorPlugin {
    /**
     * 
     * @type {string}
     * @memberof ConnectorPlugin
     */
    _class?: string;
}

export function ConnectorPluginFromJSON(json: any): ConnectorPlugin {
    return ConnectorPluginFromJSONTyped(json, false);
}

export function ConnectorPluginFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConnectorPlugin {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        '_class': !exists(json, 'class') ? undefined : json['class'],
    };
}

export function ConnectorPluginToJSON(value?: ConnectorPlugin | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'class': value._class,
    };
}

